import { render, staticRenderFns } from "./CenterBottomStats.vue?vue&type=template&id=07e59893&scoped=true"
import script from "./CenterBottomStats.vue?vue&type=script&lang=js"
export * from "./CenterBottomStats.vue?vue&type=script&lang=js"
import style0 from "./CenterBottomStats.vue?vue&type=style&index=0&id=07e59893&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e59893",
  null
  
)

export default component.exports